import React, {useEffect} from "react"
import Header from "./sections/Header";
import Main from "./sections/Main";
import Order from "./sections/Order";

import './index.scss';
import Footer from "./sections/Footer";

const Deposit = () => {

    return (
        <div className="content">
            <Header />
            <Main />
            <Order />
            <Footer />
        </div>
    )
}

export default Deposit
